// VzmSelector.js
// Copyright to Lab is Fun, Inc. All rights reserved. 2024.
import { useState } from "react";
import { Select, MenuItem, FormControl, InputLabel } from "@mui/material";
import { AppWord } from "../value/AppConst";

/**
 * Select input field.
 * Uses input dictionary to determine its behavior.
 */
export default function VzmSelector({
    dict,
    value,
    list,
    valueKey, // key of the value in the list
    labelKey, // key of the label in the list
    disabled,
    onChange,
    onSelectRecord,
    onFocused,
    fullWidth,
    size,
    style,
    variant,
    hideLabel,
    onKeyPressed,
}) {
    const [isOpen, setIsOpen] = useState(false);
    const dataKey = valueKey ? valueKey : dict.valueKey ? dict.valueKey : dict.id;
    const labelId = dict.id + '-label';
    const fcStyle = fullWidth ? {width:'100%'} : {};

    const onChangeData = (e) => {
        onChange(dict.id, e.target.value, false);
        if(onSelectRecord) {
            const item = list.find((item)=>item[dataKey]===e.target.value);
            onSelectRecord(item);
        }
    };

    const onKeyDownData = (e) => {
        console.log(`### VzmSelector onKeyDownData: ${e.key} ###`);
        if(onKeyPressed) {
            const handled = onKeyPressed(e.key, e);
            if(handled) {
                e.preventDefault();
                e.stopPropagation();
                return;
            }
        }

        const isOpenKey = e.key === 'Enter' || e.key === 'ArrowDown' || e.key === 'Down';
        if(!isOpen && isOpenKey) {
            e.preventDefault();
            e.stopPropagation();
            setIsOpen(true);
        }
    };

    if(!list) list = dict.selectList || [];
    
    const fieldInputProps = dict.inputPropsStyle ? {style:dict.inputPropsStyle} : {};
    fieldInputProps.onKeyDown = onKeyDownData;

    const menuProps = {
        MenuListProps: {
            onKeyDown: onKeyDownData,
        },
    };

    const newStyle = style ? {...style} : {};
    if(dict.minWidth && !newStyle.minWidth) newStyle.minWidth = dict.minWidth;
    if(!newStyle.minWidth) newStyle.minWidth = 100;
    if(!newStyle.fontSize) newStyle.fontSize = '0.85rem';

    return(
        <FormControl style={fcStyle} size={size || AppWord.SMALL}>
            {
                !hideLabel && dict.label &&
                <InputLabel id={labelId} style={{backgroundColor:'white'}}>
                    {dict.label}
                </InputLabel>
            }
            <Select
                labelId={labelId}
                id={dict.id}
                value={value===undefined || value===null ? '' : value}
                open={isOpen}
                onOpen={()=>setIsOpen(true)}
                onClose={()=>setIsOpen(false)}
                onChange={onChangeData}
                onKeyDown={onKeyDownData}
                SelectDisplayProps={{onKeyDown: onKeyDownData}}
                onFocus={()=>{if(onFocused) onFocused(dict)}}
                disabled={disabled}
                inputProps={fieldInputProps}
                MenuProps={menuProps}
                size={size || AppWord.SMALL}
                style={newStyle}
                required={dict.required}
                variant={variant || 'outlined'}
            >
                {list.map((item, index)=>{
                    let itemLabel = item[labelKey || dict.labelKey || 'label'];
                    return(
                        <MenuItem key={index} value={item[dataKey]}
                            style={{fontSize:'0.85rem', whiteSpace:'nowrap'}}
                        >
                            {itemLabel}
                        </MenuItem>
                    );
                })}
            </Select>
        </FormControl>
    );
}

